import { render, staticRenderFns } from "./AddPartyForm.vue?vue&type=template&id=159b6534&scoped=true"
import script from "./AddPartyForm.vue?vue&type=script&lang=ts"
export * from "./AddPartyForm.vue?vue&type=script&lang=ts"
import style0 from "./AddPartyForm.vue?vue&type=style&index=0&id=159b6534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b6534",
  null
  
)

export default component.exports